export enum DealerLanguage {
    ALL = null,
    EN = 'en',
    PT = 'pt',
    RU = 'ru',
    ES = 'es',
    PT_BT = 'pt_br',
}
